export default function HashtagIcon({ className }: { className?: string }) {
    return (
        <svg
            width="100%"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g id="tag">
                <path
                    id="tag_2"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.01 4.00146L10.5096 7.99996H14.4917L14.992 4.00146H17.01L16.5096 7.99996H20V9.99996H16.2593L15.7587 14H20V16H15.5084L15.0072 20.0051L12.99 20L13.4906 16H9.5084L9.00716 20.0051L6.99 20L7.49055 16H4V14H7.74083L8.24139 9.99996H4V7.99996H8.49166L8.99203 4.00146H11.01ZM13.7408 14L14.2414 9.99996H10.2593L9.7587 14H13.7408Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}
